import { camelCase } from 'lodash';
import { useTranslation } from 'react-i18next';
import { ApplicantStatusesEnum } from '@thinknet-gmbh/platform-common';
import {
  Button,
  ButtonsWrapper,
  CheckboxInput,
  Drawer,
  Form,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import { IApplicantsTableFilterProps } from 'src/pages/vacancies/sub-pages/vacancy-details/components/applicants/applicants.interfaces';

import { FilterContentWrapper } from './applicants-table-filter.styles';

const ApplicantsTableFilter = ({
  isOpened,
  onClose,
  setFilters,
  filters,
}: IApplicantsTableFilterProps) => {
  const { t } = useTranslation(['common', 'vacancies']);

  const onFinish = (values: any) => {
    setFilters(Object.entries(values.statuses).flatMap(([key, value]) => (value ? [key] : [])));
    onClose();
  };

  return (
    <Drawer visible={isOpened} onClose={onClose} title={t('common:buttons.filterBy')}>
      <FilterContentWrapper>
        <Typography weight="bold">{t('common:labels.status')}</Typography>
        <Form
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            statuses: Object.assign({}, ...filters.map(status => ({ [status]: true }))),
          }}
        >
          {Object.keys(ApplicantStatusesEnum).map(status => (
            <Form.Item name={['statuses', status]} valuePropName="checked" key={status}>
              <CheckboxInput>
                {t(`vacancies:labels.applicantsStatuses.${camelCase(status.toLowerCase())}`)}
              </CheckboxInput>
            </Form.Item>
          ))}
          <ButtonsWrapper marginTop={16}>
            <Button type="primary" htmlType="submit">
              {t('common:buttons.apply')}
            </Button>
            <Button
              onClick={() => {
                onClose();
                setFilters([]);
              }}
            >
              {t('common:buttons.cancel')}
            </Button>
          </ButtonsWrapper>
        </Form>
      </FilterContentWrapper>
    </Drawer>
  );
};

export default ApplicantsTableFilter;
